/**
 * Sugerencias de búsqueda con la Predictive Search API.
 */
import { theme, debounce, parseHTML } from '@theme/global';

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-predictive')) return;
    this.input = this.querySelector('[data-search-input]');
    this.results = this.querySelector('[data-predictive-results]');
    if (!this.input || !this.results) return;

    this.input.addEventListener(
      'input',
      debounce(() => this.search(this.input.value.trim()), 250)
    );

    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        const first = this.results.querySelector('a');
        if (first) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    this.results.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const links = [...this.results.querySelectorAll('a')];
      const index = links.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      if (event.key === 'ArrowUp' && index === 0) this.input.focus();
      else links[Math.min(Math.max(index + (event.key === 'ArrowDown' ? 1 : -1), 0), links.length - 1)].focus();
    });
  }

  async search(terms) {
    this.controller?.abort();
    if (!terms) {
      this.results.replaceChildren();
      return;
    }
    this.controller = new AbortController();
    const params = new URLSearchParams({
      q: terms,
      'resources[type]': 'product,collection,query,page',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last',
      section_id: 'predictive-search',
    });

    try {
      const response = await fetch(`${theme.routes.predictiveSearch}?${params}`, {
        signal: this.controller.signal,
      });
      if (!response.ok) throw new Error(String(response.status));
      const content = parseHTML(await response.text()).querySelector('.predictive');
      this.results.replaceChildren(...(content ? [content] : []));
    } catch (err) {
      if (err.name !== 'AbortError') this.results.replaceChildren();
    }
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
